import React from "react";
import Input from "../../../Input/Input";
import { createSerialKey, getFieldType, cleanValue } from "../../utils/formHelpers";

/**
 * Centralized input renderer function for all step design representations
 * Single place to modify input data passing logic
 * Returns JSX - no React component wrapper needed
 */
export const renderStandardInput = (
	item,
	step,
	itemIndex,
	options = {}
) => {
	const {
		wrapperClassName = "mb-3",
		key
	} = options;

    

	// Destructure item and extract known props, rest goes to input
	const {
		type,
		label,
		placeholder,
		required,
		options: itemOptions,
		value,
		serialize_in_top_level,
		top_level_key,
		...restItemProps  // All other props from item go directly to input (including data-selection-item!)
	} = item;

	// Prepare top level serialization attributes (available everywhere now!)
	const topLevelAttributes = {};
	if (serialize_in_top_level === 1) {
		topLevelAttributes["data-serialize-in-top-level"] = true;
		if (top_level_key) {
			topLevelAttributes["data-top-level-key"] = top_level_key;
		}
	}

	// 🎯 CENTRAL PLACE FOR INPUT PROPS - modify here to change everywhere!
	// Always use createSerialKey for consistency
	const serialKey = createSerialKey(step, label, itemIndex);
	
	const inputProps = {
		type: getFieldType(type),
		label: cleanValue(label),  // 🎯 Always use cleanValue everywhere!
		placeholder: placeholder || "",
		required: !!required,
		name: serialKey,  // 🎯 Always use serial key!
		options: itemOptions || [],
		defaultValue: value,  // defaultValue available everywhere now!
		"data-serial-key": serialKey,  // Same as name
		...topLevelAttributes,
		...restItemProps  // 🎯 All other item props passed through (including data-selection-item)!
	};

	return (
		<div className={wrapperClassName} key={key}>
			<Input {...inputProps} />
		</div>
	);
};

// Keep backward compatibility - but this component just calls the function
const StandardInputRenderer = ({ 
	item,
	step,
	itemIndex,
	wrapperClassName = "mb-3"
}) => {
	return renderStandardInput(item, step, itemIndex, { wrapperClassName });
};

export default StandardInputRenderer;
